import { z } from 'zod';

export const CustomerDisplayFormSchema = z.object({
  name: z.string().min(1, 'Name can not be empty'),
  images: z
    .object({
      id: z.number().optional(),
      name: z.string(),
      url: z.string(),
    })
    .array()
    .min(1, 'Image can not be empty')
    .max(5, 'Max 5 images'),
  duration: z.coerce.number().min(1, 'Duration can not be empty'),
  setTimePeriod: z.boolean(),
  timePeriod: z.object({
    startDate: z.date(),
    endDate: z.date(),
  }),
  outletIds: z.array(z.coerce.number(), { errorMap: () => ({ message: 'Must assign at least 1 outlet' }) }).nonempty(),
});

export type CustomerDisplayFormSchemaType = z.infer<typeof CustomerDisplayFormSchema>;
